import {Howl, Howler} from "howler";
import * as PIXI from "pixi.js";
import {config} from "../config";
import data from "./configs/data";
import {CheckBox} from "./controlElements/CheckBox";
import {RangeSlider} from "./controlElements/RangeSlider";
import {Dice} from "./Dice";
import {PredictionPickerTextField} from "./PredictionPickerTextField";

export class PredictionPicker extends PIXI.Container {

    private readonly BELOW_CHECKBOX_POSITION: any = new PIXI.Point(-102, 5);
    private readonly ABOVE_CHECKBOX_POSITION: any = new PIXI.Point(102, 5);
    private readonly BELOW_CHECKBOX_LABEL_POSITION: any = new PIXI.Point(-105, 0);
    private readonly ABOVE_CHECKBOX_LABEL_POSITION: any = new PIXI.Point(105, 0);
    private readonly BET_BAR_POSITION: any = new PIXI.Point(-473, 68);
    private readonly ROLL_UNDER_FIELD_POSITION: any = new PIXI.Point(-244, 210);
    private readonly PAYOUT_FIELD_POSITION: any = new PIXI.Point(0, 210);
    private readonly WIN_CHANCE_FIELD_POSITION: any = new PIXI.Point(240, 210);

    private readonly INITIAL_NUMBER_VALUE = 49;
    private readonly TOTAL_DICE_NUMBERS_AMOUNT = 100;

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private readonly PRIZE_MULTIPLIER_BELOW_NUMBER = {
        2: 98.00,
        3: 49.00,
        4: 32.667,
        5: 24.50,
        6: 19.60,
        7: 16.333,
        8: 14.00,
        9: 12.25,
        10: 10.889,
        11: 9.80,
        12: 8.909,
        13: 8.167,
        14: 7.538,
        15: 7.00,
        16: 6.533,
        17: 6.125,
        18: 5.765,
        19: 5.444,
        20: 5.158,
        21: 4.90,
        22: 4.667,
        23: 4.455,
        24: 4.261,
        25: 4.083,
        26: 3.92,
        27: 3.769,
        28: 3.63,
        29: 3.50,
        30: 3.379,
        31: 3.267,
        32: 3.161,
        33: 3.063,
        34: 2.970,
        35: 2.882,
        36: 2.80,
        37: 2.722,
        38: 2.649,
        39: 2.579,
        40: 2.513,
        41: 2.45,
        42: 2.39,
        43: 2.333,
        44: 2.279,
        45: 2.227,
        46: 2.178,
        47: 2.130,
        48: 2.085,
        49: 2.042,
        50: 2.000,
        51: 1.960,
        52: 1.922,
        53: 1.885,
        54: 1.849,
        55: 1.815,
        56: 1.782,
        57: 1.750,
        58: 1.719,
        59: 1.690,
        60: 1.661,
        61: 1.633,
        62: 1.607,
        63: 1.581,
        64: 1.556,
        65: 1.531,
        66: 1.508,
        67: 1.485,
        68: 1.463,
        69: 1.441,
        70: 1.420,
        71: 1.400,
        72: 1.380,
        73: 1.361,
        74: 1.342,
        75: 1.324,
        76: 1.307,
        77: 1.289,
        78: 1.273,
        79: 1.256,
        80: 1.241,
        81: 1.225,
        82: 1.210,
        83: 1.195,
        84: 1.181,
        85: 1.167,
        86: 1.153,
        87: 1.140,
        88: 1.126,
        89: 1.114,
        90: 1.101,
        91: 1.089,
        92: 1.077,
        93: 1.065,
        94: 1.054,
        95: 1.043,
    };

    private readonly PRIZE_MULTIPLIER_ABOVE_NUMBER = {
        99: 98.00,
        98: 49.00,
        97: 32.667,
        96: 24.50,
        95: 19.60,
        94: 16.333,
        93: 14.00,
        92: 12.25,
        91: 10.889,
        90: 9.80,
        89: 8.909,
        88: 8.167,
        87: 7.538,
        86: 7.00,
        85: 6.533,
        84: 6.125,
        83: 5.765,
        82: 5.444,
        81: 5.158,
        80: 4.90,
        79: 4.667,
        78: 4.455,
        77: 4.261,
        76: 4.083,
        75: 3.92,
        74: 3.769,
        73: 3.63,
        72: 3.50,
        71: 3.379,
        70: 3.267,
        69: 3.161,
        68: 3.063,
        67: 2.970,
        66: 2.882,
        65: 2.80,
        64: 2.722,
        63: 2.649,
        62: 2.579,
        61: 2.513,
        60: 2.45,
        59: 2.39,
        58: 2.333,
        57: 2.279,
        56: 2.227,
        55: 2.178,
        54: 2.130,
        53: 2.085,
        52: 2.042,
        51: 2.000,
        50: 1.960,
        49: 1.922,
        48: 1.885,
        47: 1.849,
        46: 1.815,
        45: 1.782,
        44: 1.750,
        43: 1.719,
        42: 1.690,
        41: 1.661,
        40: 1.633,
        39: 1.607,
        38: 1.581,
        37: 1.556,
        36: 1.531,
        35: 1.508,
        34: 1.485,
        33: 1.463,
        32: 1.441,
        31: 1.420,
        30: 1.400,
        29: 1.380,
        28: 1.361,
        27: 1.342,
        26: 1.324,
        25: 1.307,
        24: 1.289,
        23: 1.273,
        22: 1.256,
        21: 1.241,
        20: 1.225,
        19: 1.210,
        18: 1.195,
        17: 1.181,
        16: 1.167,
        15: 1.153,
        14: 1.140,
        13: 1.126,
        12: 1.114,
        11: 1.101,
        10: 1.089,
        9: 1.077,
        8: 1.065,
        7: 1.054,
        6: 1.043,
    };

    private readonly ABOVE_BELOW_CHOSEN_STYLE = {
        fontSize: 32,
        fontFamily: "RobotoRegular",
        fontWeight: "bolder",
        fill: "#000000",
    };

    private readonly ABOVE_BELOW_UNCHOSEN_STYLE = {
        fontSize: 32,
        fontFamily: "RobotoRegular",
        fontWeight: "bolder",
        fill: "#ffffff",
    };

    private BELOW_QUANTIZED_VALUES: Array<number> = [];
    private ABOVE_QUANTIZED_VALUES: Array<number> = [];
    private belowCheckBox: CheckBox;
    private aboveCheckBox: CheckBox;
    private valueRangeSlider: RangeSlider;
    private belowCheckBoxLabel: PIXI.Text;
    private aboveCheckBoxLabel: PIXI.Text;
    private rollUnderAboveField: PredictionPickerTextField;
    private payoutField: PredictionPickerTextField;
    private winChanceField: PredictionPickerTextField;
    private onPayoutFactorChangedlisteners: Array<Function> = [];
    private chosenNumber: number;
    private belowNumber = true;
    private bettingBarDownSound: Howl;
    private bettingBarUpSound: Howl;

    constructor() {
        super();

        this.initializeQuantizedValues();

        this.createAndAddBelowCheckbox();
        this.createAndAddAboveCheckbox();
        this.createAndAddBelowLabel();
        this.createAndAddAboveLabel();
        this.createAndAddValueSlider();
        this.createAndAddRollUnderField();
        this.createAndAddPayoutField();
        this.createAndAddWinChanceField();
        this.chosenNumber = this.INITIAL_NUMBER_VALUE;
        this.setPredictionFieldsValues();
        this.bettingBarDownSound = new Howl({
            src: [data.audios.bettingBarDown],
            volume: 0.1,
        });
        this.bettingBarUpSound = new Howl({
            src: [data.audios.bettingBarUp],
            volume: 0.1,
        });
    }

    public getChosenNomber(): number {
        return this.chosenNumber;
    }

    public isBetBelowChosenNumber(): boolean {
        return this.belowNumber;
    }

    public addOnBetFactorChangedListener(listener: Function): void {
        this.onPayoutFactorChangedlisteners.push(listener);
    }

    private setPredictionFieldsValues(): void {
        this.rollUnderAboveField.setValue("" + this.chosenNumber);
        if (this.belowNumber) {
            this.payoutField.setValue((this.PRIZE_MULTIPLIER_BELOW_NUMBER["" + this.chosenNumber]).toFixed(config.betDisplayPrecision + 1) + "x");
        } else {
            this.payoutField.setValue((this.PRIZE_MULTIPLIER_ABOVE_NUMBER["" + this.chosenNumber]).toFixed(config.betDisplayPrecision + 1) + "x");
        }
        if (this.belowNumber) {
            this.winChanceField.setValue(
                (((this.chosenNumber - 1) / this.TOTAL_DICE_NUMBERS_AMOUNT) * 100).toFixed(config.betDisplayPrecision) + "%");
        } else {
            this.winChanceField.setValue(
                (((this.TOTAL_DICE_NUMBERS_AMOUNT - this.chosenNumber) /
                    this.TOTAL_DICE_NUMBERS_AMOUNT) * 100).toFixed(config.betDisplayPrecision) + "%");
        }
    }

    private createAndAddRollUnderField(): void {
        this.rollUnderAboveField = new PredictionPickerTextField("ROLL UNDER");
        this.rollUnderAboveField.position = this.ROLL_UNDER_FIELD_POSITION;
        this.addChild(this.rollUnderAboveField);
    }

    private createAndAddPayoutField(): void {
        this.payoutField = new PredictionPickerTextField("PAYOUT");
        this.payoutField.position = this.PAYOUT_FIELD_POSITION;
        this.addChild(this.payoutField);
    }

    private createAndAddWinChanceField(): void {
        this.winChanceField = new PredictionPickerTextField("WIN CHANCE");
        this.winChanceField.position = this.WIN_CHANCE_FIELD_POSITION;
        this.addChild(this.winChanceField);
    }

    private createAndAddValueSlider(): void {
        this.valueRangeSlider = new RangeSlider(
            data.images.betBarButtonBase, data.images.betBarButtonActive, data.images.betBarBackground,
            data.images.betBarCover, this.BELOW_QUANTIZED_VALUES[0],
            this.ABOVE_QUANTIZED_VALUES[this.ABOVE_QUANTIZED_VALUES.length - 1]);
        this.valueRangeSlider.position = this.BET_BAR_POSITION;
        this.valueRangeSlider.setValuesQuantization(this.BELOW_QUANTIZED_VALUES);
        this.valueRangeSlider.scale = Dice.ELEMENTS_SCALE;
        this.valueRangeSlider.setValue(this.INITIAL_NUMBER_VALUE);
        this.valueRangeSlider.subscribeOnValueChanged((value: number) => {
            this.tryToPlayBelowSound(value);
            this.tryToPlayAboveSound(value);
            this.chosenNumber = value;
            this.setPredictionFieldsValues();
            this.callOnFactorChangedListeners();
        });
        this.addChild(this.valueRangeSlider);
    }

    private tryToPlayBelowSound(value: number): void {
        if (this.chosenNumber < value) {
            this.bettingBarDownSound.play();
        }
    }

    private tryToPlayAboveSound(value: number): void {
        if (this.chosenNumber > value) {
            this.bettingBarUpSound.play();
        }
    }

    private initializeQuantizedValues(): void {
        for (let i = 2; i <= 95; i++) {
            this.BELOW_QUANTIZED_VALUES.push(i);
        }
        for (let i = 6; i <= 99; i++) {
            this.ABOVE_QUANTIZED_VALUES.push(i);
        }
    }

    private createAndAddBelowLabel(): void {
        this.belowCheckBoxLabel = new PIXI.Text("BELOW", this.ABOVE_BELOW_CHOSEN_STYLE);
        this.belowCheckBoxLabel.anchor = this.DEFAULT_ANCHOR_POINT;
        this.belowCheckBoxLabel.position = this.BELOW_CHECKBOX_LABEL_POSITION;
        this.addChild(this.belowCheckBoxLabel);
    }

    private createAndAddAboveLabel(): void {
        this.aboveCheckBoxLabel = new PIXI.Text("ABOVE", this.ABOVE_BELOW_UNCHOSEN_STYLE);
        this.aboveCheckBoxLabel.anchor = this.DEFAULT_ANCHOR_POINT;
        this.aboveCheckBoxLabel.position = this.ABOVE_CHECKBOX_LABEL_POSITION;
        this.addChild(this.aboveCheckBoxLabel);
    }

    private createAndAddBelowCheckbox(): void {
        this.belowCheckBox = new CheckBox(
            data.images.uncheckedAboveBelowBase, data.images.uncheckedAboveBelowHover,
            data.images.uncheckedAboveBelowClicked, data.images.uncheckedAboveBelowBase,
            data.images.checkedAboveBelowBase, data.images.checkedAboveBelowHover,
            data.images.checkedAboveBelowClicked, data.images.checkedAboveBelowBase,
            data.audios.buttonClicked);
        this.belowCheckBox.scale = Dice.ELEMENTS_SCALE;
        this.belowCheckBox.position = this.BELOW_CHECKBOX_POSITION;
        this.belowCheckBox.checked = true;
        this.belowCheckBox.enabled = false;
        this.belowCheckBox.subscribeOnClicked((checked) => {
            this.belowCheckBox.enabled = false;
            this.belowCheckBox.checked = true;
            this.aboveCheckBox.checked = false;
            this.aboveCheckBox.enabled = true;
            this.belowNumber = true;
            this.valueRangeSlider.belowActiveBackground = true;
            this.rollUnderAboveField.setHeader("ROLL UNDER");
            if (this.chosenNumber > this.BELOW_QUANTIZED_VALUES[this.BELOW_QUANTIZED_VALUES.length - 1]) {
                this.valueRangeSlider.setValue(this.BELOW_QUANTIZED_VALUES[this.BELOW_QUANTIZED_VALUES.length - 1]);
                this.chosenNumber = this.BELOW_QUANTIZED_VALUES[this.BELOW_QUANTIZED_VALUES.length - 1];
            }
            this.valueRangeSlider.setValuesQuantization(this.BELOW_QUANTIZED_VALUES);
            this.belowCheckBoxLabel.style.fill = this.ABOVE_BELOW_CHOSEN_STYLE.fill;
            this.aboveCheckBoxLabel.style.fill = this.ABOVE_BELOW_UNCHOSEN_STYLE.fill;
            this.setPredictionFieldsValues();
            this.callOnFactorChangedListeners();
        });
        this.addChild(this.belowCheckBox);
    }

    private createAndAddAboveCheckbox(): void {
        this.aboveCheckBox = new CheckBox(
            data.images.uncheckedAboveBelowBase, data.images.uncheckedAboveBelowHover,
            data.images.uncheckedAboveBelowClicked, data.images.uncheckedAboveBelowBase,
            data.images.checkedAboveBelowBase, data.images.checkedAboveBelowHover,
            data.images.checkedAboveBelowClicked, data.images.checkedAboveBelowBase,
            data.audios.buttonClicked);
        this.aboveCheckBox.scale = Dice.ELEMENTS_SCALE;
        this.aboveCheckBox.position = this.ABOVE_CHECKBOX_POSITION;
        this.aboveCheckBox.subscribeOnClicked((checked) => {
            this.belowCheckBox.checked = false;
            this.belowCheckBox.enabled = true;
            this.aboveCheckBox.checked = true;
            this.aboveCheckBox.enabled = false;
            this.belowNumber = false;
            this.valueRangeSlider.belowActiveBackground = false;
            this.rollUnderAboveField.setHeader("ROLL ABOVE");
            if (this.chosenNumber < this.ABOVE_QUANTIZED_VALUES[0]) {
                this.valueRangeSlider.setValue(this.ABOVE_QUANTIZED_VALUES[0]);
                this.chosenNumber = this.ABOVE_QUANTIZED_VALUES[0];
            }
            this.valueRangeSlider.setValuesQuantization(this.ABOVE_QUANTIZED_VALUES);
            this.belowCheckBoxLabel.style.fill = this.ABOVE_BELOW_UNCHOSEN_STYLE.fill;
            this.aboveCheckBoxLabel.style.fill = this.ABOVE_BELOW_CHOSEN_STYLE.fill;
            this.setPredictionFieldsValues();
            this.callOnFactorChangedListeners();
        });
        this.addChild(this.aboveCheckBox);
    }

    private callOnFactorChangedListeners(): void {
        for (let i = 0; i < this.onPayoutFactorChangedlisteners.length; i++) {
            if (this.belowNumber) {
                this.onPayoutFactorChangedlisteners[i](this.PRIZE_MULTIPLIER_BELOW_NUMBER["" + this.chosenNumber]);
            } else {
                this.onPayoutFactorChangedlisteners[i](this.PRIZE_MULTIPLIER_ABOVE_NUMBER["" + this.chosenNumber]);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/PredictionPicker.ts